<template>
<div class="chapter">
<div class="inner_page">
<div id="fm"><span id="page1">
<p class="center0">Lynn Newman has a gif of large perception.</p>
<p class="center"><span class="blue1">Natalie Goldberg, author of <em>Writing Down the Bones</em></span></p>
<p class="center0">Because Lynn knows her own creativity deep</p>
<p class="center">from the inside, she is able to creatively inspire others</p>
<p class="center">to explore and discover their freest selves.</p>
<p class="center"><span class="blue1">Michele Cassou, author of <em>Life, Paint and Passion</em></span></p>
<p class="center0">Part memoir and part workbook, <em>The Muse in You</em></p>
<p class="center">may be just what you need to heal from your pain and be</p>
<p class="center">reborn as someone more passionate, purposeful, and alive.</p>
<p class="center"><span class="blue1">Lori Deschene, author of <em>Tiny Buddha’s Worry Journal</em> and others</span></p>
<p class="center0">There is no better guide than Lynn for helping you</p>
<p class="center">befriend your inner muse. Lynn’s priceless combination</p>
<p class="center">of humor, vulnerability, and straight-up truth-telling</p>
<p class="center">will inspire you to overcome life’s challenges … a beacon of</p>
<p class="center">hope, a fountain of wisdom, and a treasure of tools to call</p>
<p class="center">out your inner creative strength and resiliency.</p>
<p class="center"><span class="blue1">Heather Ash Amara, author of <em>Warrior Goddess Training</em></span><span id="page2"></span></p>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c02_fm.vue?0fc13846